import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import FileUploader from "../../shared/components/file-uploader/FileUploader";
import CustomError from "../../shared/components/custom-error/CustomError";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { EditIcon } from "../../assets";
import { allowedFileTypesForRegistrationCertificate } from "../../constants";

const AgentFiles = ({ isEditing, setDeletedImageIds, handleChangeEditor }) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  // Watch the file input to see its value
  const files = watch("files");
  const headshotfiles = watch("headshotfiles");
  const document = watch("document");

  return (
    <div className="grey-bg-wrapper">
      <div className="d-flex justify-content-between">
        <div className="heading">Files</div>
        {!isEditing && (
          <div
            className="edit-button pointer"
            onClick={() => handleChangeEditor(true)}
          >
            <img src={EditIcon} alt="edit-icon" />
            Edit
          </div>
        )}
      </div>
      <div className="row">
        {/* upload your photo id field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              {isEditing && "Upload your "}Photo ID: <span>Front and Back</span>
            </div>
            <Controller
              name="files"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  disabled={!isEditing}
                  displayDisabled={false}
                  files={files || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...files];
                    if (files[index]?.id) {
                      setDeletedImageIds((prev) => [...prev, files[index]?.id]);
                    }
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={2}
                />
              )}
            />
            <CustomError errorMessage={errors?.files?.message} />
          </div>
        </div>
        {/* upload headshot photo field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              {isEditing && "Upload "}Professional Headshot:
            </div>
            <Controller
              name="headshotfiles"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  disabled={!isEditing}
                  displayDisabled={false}
                  files={headshotfiles || []}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...headshotfiles];
                    if (headshotfiles[index]?.id) {
                      setDeletedImageIds((prev) => [
                        ...prev,
                        headshotfiles[index]?.id,
                      ]);
                    }
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError errorMessage={errors?.headshotfiles?.message} />
          </div>
        </div>
        {/* upload registration certificate field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="upload-photo-wrapper">
            <div className="upload-photo mb-3">
              {isEditing && "Upload "}Registration Certificate:
            </div>
            <Controller
              name="document"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUploader
                  disabled={!isEditing}
                  displayDisabled={false}
                  files={document || []}
                  accept={allowedFileTypesForRegistrationCertificate}
                  onChange={onChange}
                  handleDelete={(index) => {
                    // Remove file from the array
                    const updatedFiles = [...document];
                    if (document[index]?.id) {
                      setDeletedImageIds((prev) => [
                        ...prev,
                        document[index]?.id,
                      ]);
                    }
                    updatedFiles.splice(index, 1);
                    onChange(updatedFiles);
                  }}
                  maxFiles={1}
                />
              )}
            />
            <CustomError errorMessage={errors?.document?.message} />
          </div>
        </div>
      </div>
      {isEditing && (
        <div className="mt-4 d-flex justify-content-center gap-3">
          <RoundedButton className="px-4 px-md-5 py-1" type="submit">
            Update
          </RoundedButton>
          <RoundedButton
            className="px-4 px-md-5 py-1"
            variant="outlined"
            onClick={() => handleChangeEditor(false)}
          >
            Cancel
          </RoundedButton>
        </div>
      )}
    </div>
  );
};

export default AgentFiles;
